<div class="mfa-grace-banner" *ngIf="visible()">
  <span class="mfa-grace-banner-icon"><fa-icon [icon]="faShieldHalved"></fa-icon></span>
  <div class="mfa-grace-banner-copy">
    <span class="mfa-grace-banner-title">Two-factor authentication required</span>
    <span class="mfa-grace-banner-subtitle">
      Set it up {{ deadlineLabel }}<ng-container *ngIf="graceUntil()"> (by {{ graceUntil() | date:'d MMM' }})</ng-container>
      to keep full access. It takes about a minute with an authenticator app.
    </span>
  </div>
  <button type="button" class="btn btn-sm btn-primary mfa-grace-banner-action" (click)="openSetup()">
    Set up now
  </button>
</div>
